module.exports = __webpack_public_path__ + "static/media/read_content_aloud_gujarati.61d496d7.mp3";